import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

import { SCMPYoutubeVideo } from "scmp-app/components/scmp-youtube-video";
import {
  PlayButton,
  Container as PreviewContainer,
} from "scmp-app/components/scmp-youtube-video/scmp-youtube-video-preview/styles";

/** Positioned wrapper: the action buttons and progress bar are siblings of
 * SCMPYoutubeVideo (which does not accept children), so this wrapper is
 * their positioning and hover context.
 */
export const VideoWrapper = styled.div`
  position: relative;

  inline-size: 100%;
`;

export const StyledSCMPYoutubeVideo = styled(SCMPYoutubeVideo)`
  ${PreviewContainer} {
    row-gap: 8px;

    ${theme.breakpoints.up("tablet")} {
      row-gap: 8px;
    }
  }

  ${PlayButton} {
    inline-size: 60px;
    block-size: 60px;
  }
`;

/** Hover-only container for the player action buttons (share, mute). The
 * SVGs carry their own circular backgrounds; the buttons themselves are
 * plain flex items.
 */
export const ButtonsContainer = styled.div`
  position: absolute;
  inset-block-end: 28px;
  inset-inline-end: 16px;
  z-index: 2;

  display: flex;
  flex-direction: column;
  gap: 16px;

  opacity: 0;

  transition: opacity 0.25s ease;

  ${VideoWrapper}:hover & {
    opacity: 1;
  }
`;

export const MuteButton = styled.button`
  display: flex;

  padding: 0;

  border: none;

  background: none;

  cursor: pointer;

  svg {
    inline-size: 32px;
    block-size: 32px;
  }
`;

export const ShareButton = styled(MuteButton)`
  position: relative;
`;

/** Seekable progress strip along the bottom edge, visible only while
 * hovering the player area. The track itself is SCMPYoutubeVideoProgressBar;
 * this wrapper only positions it and toggles its visibility.
 */
export const ProgressBar = styled.div`
  position: absolute;
  inset-block-end: 0;
  inset-inline: 0;

  display: flex;
  align-items: flex-end;

  opacity: 0;

  transition: opacity 0.25s ease;

  ${VideoWrapper}:hover & {
    opacity: 1;
  }
`;

export const LinkCopied = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  inset-block-start: 5px;
  inset-inline-end: 40px;

  display: ${props => (props.$isVisible ? "block" : "none")};

  padding-block: 4px;
  padding-inline: 6px;

  color: #ffffff;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 100%;
  white-space: nowrap;

  background-color: #000000;
`;
